import { OnSiteVisit, OnSiteVisitsState } from './types';
import { ReduxAction, setAsyncData } from '../../core';

import { OnSiteVisitsAction } from './actions';
import { TimeSlot } from '../../visits/types';

const initialState: OnSiteVisitsState = {
  onSiteVisits: { isFetching: false },
  onSiteVisitCodeToVisitIndex: {},
  availableOnSiteTimeSlots: { isFetching: false },
};

export function onSiteVisitsReducer(state: OnSiteVisitsState = initialState, action: ReduxAction<any>): OnSiteVisitsState {
  switch (action.type) {
    case OnSiteVisitsAction.SET_ONSITE_IS_FETCHING:
      return {
        ...state,
        onSiteVisits: setAsyncData(state.onSiteVisits, (v) => (v.isFetching = action.data as boolean)),
      };

    case OnSiteVisitsAction.SET_ONSITE_VISITS:
      const onSiteVisits = action.data as OnSiteVisit[];
      const onSiteVisitCodeToVisitIndex: { [code: string]: number } = {};
      onSiteVisits.forEach((v, i) => (onSiteVisitCodeToVisitIndex[v.visitCode] = i));
      return {
        ...state,
        onSiteVisits: setAsyncData(state.onSiteVisits, (v) => (v.data = action.data as OnSiteVisit[])),
        onSiteVisitCodeToVisitIndex,
      };

    case OnSiteVisitsAction.SET_ONSITE_VISIT:
      const newOnSiteVisit = action.data as OnSiteVisit;
      const OnSiteIndex = state.onSiteVisitCodeToVisitIndex[newOnSiteVisit.visitCode];
      return {
        ...state,
        onSiteVisits: setAsyncData(state.onSiteVisits, (v) => {
          const newVisits = v.data ? v.data.slice() : [];
          newVisits[OnSiteIndex] = newOnSiteVisit;
          v.data = newVisits;
        }),
      };

    case OnSiteVisitsAction.SET_AVAILABLE_ONSITE_TIME_SLOTS_FETCHING:
      return {
        ...state,
        availableOnSiteTimeSlots: setAsyncData(state.availableOnSiteTimeSlots, (v) => (v.isFetching = action.data)),
      };

    case OnSiteVisitsAction.SET_AVAILABLE_ONSITE_TIME_SLOTS:
      return {
        ...state,
        availableOnSiteTimeSlots: setAsyncData(state.availableOnSiteTimeSlots, (v) => (v.data = action.data.value as TimeSlot[])),
      };

    default:
      return state;
  }
}
